import { render, staticRenderFns } from "./crossChats.vue?vue&type=template&id=40944dd6&scoped=true"
import script from "./crossChats.vue?vue&type=script&lang=js"
export * from "./crossChats.vue?vue&type=script&lang=js"
import style0 from "./crossChats.vue?vue&type=style&index=0&id=40944dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40944dd6",
  null
  
)

export default component.exports